import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, useBreakpoint } from '@airtel/air-design-system';
import { useRef, useState } from 'react';
import { Image, Pressable, ScrollView, StyleSheet, View } from 'react-native';
var getStyles = isSmallScreen => StyleSheet.create({
  container: {
    alignItems: 'center',
    flex: 1,
    backgroundColor: '#fff'
  },
  titleContainer: {
    width: '100%',
    alignItems: 'center'
  },
  titleMobileContainer: {
    width: '100%'
  },
  tabScroller: {
    flex: 1
  },
  tabContainer: {
    flexDirection: 'row',
    marginTop: 30
  },
  imageScroller: {
    flex: 1,
    marginTop: 25,
    flexDirection: 'row'
  },
  imageContainer: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  tabItem: {
    borderColor: '#C2CAD6',
    paddingVertical: isSmallScreen ? 3 : 8,
    paddingHorizontal: isSmallScreen ? 8 : 40,
    borderWidth: 1,
    borderRadius: 40,
    marginLeft: isSmallScreen ? 12 : 30
  },
  selectedTab: {
    borderColor: '#000'
  },
  image: {
    marginLeft: 24,
    borderRadius: 11
  },
  mobileImageScroller: {
    flex: 0,
    width: '100%'
  },
  mobileTabScroller: {
    flex: 0,
    width: '100%'
  },
  subtitle: {
    marginTop: 40,
    width: '50%'
  },
  subtitleMobile: {
    marginTop: 20,
    width: '100%'
  },
  subHeading: {
    marginTop: 15,
    width: '50%'
  },
  bottomCta: {
    borderColor: '#000',
    borderWidth: 1,
    paddingVertical: 11,
    paddingHorizontal: 24,
    borderRadius: 30,
    marginTop: 10
  }
});
export var TabContainerWidgetComponent = props => {
  var _a;
  var title = props.title,
    subtitle = props.subtitle,
    subHeading = props.subHeading,
    _props$tab = props.tab,
    tab = _props$tab === void 0 ? {} : _props$tab,
    noTabImages = props.noTabImages,
    bottomCta = props.bottomCta,
    style = props.style,
    bottomCtaStyle = props.bottomCtaStyle,
    _onPress = props.onPress;
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var platform = isSmallScreen ? 'mobile' : 'web';
  var heads = Object.keys(tab);
  var _useState = useState(heads[0]),
    selected = _useState[0],
    setSelected = _useState[1];
  var scrollView = useRef(null);
  var scrollView2 = useRef(null);
  var styles = getStyles(isSmallScreen);
  return _jsxs(View, Object.assign({
    style: Object.assign(Object.assign({}, styles.container), style)
  }, {
    children: [title && Array.isArray(title) && title.length ? _jsxs(View, Object.assign({
      style: isSmallScreen ? styles.titleMobileContainer : styles.titleContainer
    }, {
      children: [_jsx(Typography, {
        multiText: title,
        alignItems: "center",
        justifyContent: "center",
        fontWeight: '700',
        fontSize: isSmallScreen ? 12 : 32,
        lineHeight: isSmallScreen ? 32 : 42,
        letterSpacing: -0.1,
        textAlign: "center",
        style: {
          width: '100%'
        },
        textAlignment: "center",
        type: isSmallScreen ? 'h4-bold' : 'h3-bold'
      }), ' ']
    })) : null, subtitle ? _jsx(View, Object.assign({
      style: isSmallScreen ? styles.subtitleMobile : styles.subtitle
    }, {
      children: _jsx(Typography, {
        text: subtitle,
        color: "#000",
        fontWeight: '400',
        fontSize: 18,
        lineHeight: 32,
        letterSpacing: -0.1,
        style: {
          textAlign: 'center'
        },
        type: "body-para-lg"
      })
    })) : null, subHeading ? _jsx(View, Object.assign({
      style: styles.subHeading
    }, {
      children: _jsx(Typography, {
        text: subHeading,
        color: "#7B8BA3",
        fontWeight: '600',
        fontSize: 14,
        lineHeight: 32,
        letterSpacing: -0.1,
        style: {
          textAlign: 'center'
        },
        textAlign: "center",
        type: "body-para-md-bold"
      })
    })) : null, _jsx(ScrollView, Object.assign({
      horizontal: true,
      showsHorizontalScrollIndicator: false,
      showsVerticalScrollIndicator: false,
      keyboardShouldPersistTaps: "handled",
      style: [styles.tabScroller, isSmallScreen ? styles.mobileTabScroller : null]
    }, {
      children: _jsx(View, Object.assign({
        style: styles.tabContainer
      }, {
        children: heads.map(tab => {
          return _jsx(Pressable, Object.assign({
            onPress: () => {
              var _a, _b;
              setSelected(tab);
              (_a = scrollView === null || scrollView === void 0 ? void 0 : scrollView.current) === null || _a === void 0 ? void 0 : _a.scrollTo({
                y: 0,
                x: 0
              });
              (_b = scrollView2 === null || scrollView2 === void 0 ? void 0 : scrollView2.current) === null || _b === void 0 ? void 0 : _b.scrollTo({
                y: 0,
                x: 0
              });
            }
          }, {
            children: _jsx(View, Object.assign({
              style: [styles.tabItem, selected === tab ? styles.selectedTab : null]
            }, {
              children: _jsx(Typography, {
                text: tab,
                color: "#000",
                type: selected === tab ? 'title-para-lg' : 'title-para-md'
              })
            }))
          }));
        })
      }))
    })), tab[selected] && ((_a = tab[selected]) === null || _a === void 0 ? void 0 : _a.length) ? _jsx(ScrollView, Object.assign({
      ref: scrollView.current,
      horizontal: true,
      style: [styles.imageScroller, isSmallScreen ? styles.mobileImageScroller : null],
      showsHorizontalScrollIndicator: false,
      showsVerticalScrollIndicator: false,
      keyboardShouldPersistTaps: "handled"
    }, {
      children: _jsx(View, Object.assign({
        style: styles.imageContainer
      }, {
        children: tab[selected].map(imageObj => {
          var _a, _b;
          return _jsx(Pressable, Object.assign({
            onPress: () => props.onUserAction(imageObj.onPress || _onPress || {
              actions: [{
                type: 'navigation',
                payload: {
                  screenName: imageObj.link
                }
              }]
            }, imageObj)
          }, {
            children: _jsx(Image, {
              source: {
                uri: (_a = imageObj === null || imageObj === void 0 ? void 0 : imageObj[platform]) === null || _a === void 0 ? void 0 : _a.url
              },
              style: [styles.image, (_b = imageObj === null || imageObj === void 0 ? void 0 : imageObj[platform]) === null || _b === void 0 ? void 0 : _b.imageStyle],
              resizeMode: 'contain'
            })
          }));
        })
      }))
    })) : noTabImages && noTabImages.length ? _jsx(ScrollView, Object.assign({
      ref: scrollView2.current,
      horizontal: true,
      style: [styles.imageScroller, isSmallScreen ? styles.mobileImageScroller : null],
      showsHorizontalScrollIndicator: false,
      showsVerticalScrollIndicator: false,
      keyboardShouldPersistTaps: "handled"
    }, {
      children: _jsx(View, Object.assign({
        style: styles.imageContainer
      }, {
        children: noTabImages.map(imageObj => {
          var _a, _b;
          return _jsx(Pressable, Object.assign({
            onPress: () => props.onUserAction(imageObj.onPress || _onPress || {
              actions: [{
                type: 'navigation',
                payload: {
                  screenName: imageObj.link
                }
              }]
            }, imageObj)
          }, {
            children: _jsx(Image, {
              source: {
                uri: (_a = imageObj === null || imageObj === void 0 ? void 0 : imageObj[platform]) === null || _a === void 0 ? void 0 : _a.url
              },
              style: [styles.image, (_b = imageObj === null || imageObj === void 0 ? void 0 : imageObj[platform]) === null || _b === void 0 ? void 0 : _b.imageStyle],
              resizeMode: 'contain'
            })
          }));
        })
      }))
    })) : null, bottomCta ? _jsx(Pressable, Object.assign({
      style: [styles.bottomCta, bottomCtaStyle],
      onPress: () => props.onUserAction(bottomCta.onPress || {
        actions: [{
          type: 'navigation',
          payload: {
            screenName: bottomCta.link
          }
        }]
      }, props)
    }, {
      children: _jsx(Typography, {
        text: bottomCta.text,
        color: "#000",
        fontWeight: '600',
        fontSize: 14,
        lineHeight: 18,
        letterSpacing: 0.2,
        style: {
          textAlign: 'center'
        },
        textAlign: "center",
        type: "body-para-md-bold"
      })
    })) : null]
  }));
};
TabContainerWidgetComponent.genericRendererKey = 'AirTabContainerWidget';